import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyBaq6jLuQkKfknnFxbeubKjRTpj4hQ66p0",
    authDomain: "sunset-to.firebaseapp.com",
    projectId: "sunset-to",
    storageBucket: "sunset-to.firebasestorage.app",
    messagingSenderId: "712691489951",
    appId: "1:712691489951:web:bab40405dcc86a737916aa",
    measurementId: "G-EDYQWWYZZC"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default db;
